angular.module('bmsApp.dashboard')
	.controller('TrainingDashboardCtrl', TrainingDashboardCtrl);

TrainingDashboardCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'SharedTrainingSvc',
	'InstanceSvc',
];

function TrainingDashboardCtrl(
	$scope,
	$state,
	$q,
	SharedTrainingSvc,
	InstanceSvc
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		franchiseLoading: true,
		employeeLoading: true,
		franchisePage: 1,
		employeePage: 1,
		filter: {
			franchise: {
				status: 'outstanding',
			},
			employee: {
				status: 'outstanding',
			},
		}
	});

	this.$onInit = () => {
		loadFranchiseTraining();
		loadEmployeeTraining();
	};

	function loadFranchiseTraining() {
		self.franchiseLoading = true;
		let params = {
			page: self.franchisePage,
			count: 20,
			filter: {
				franchiseCourse: true,
				completed: self.filter.franchise.status !== 'outstanding',
				search: self.filter.franchise.search,
				expiringCoursesOnly: self.filter.franchise.show_expiring_courses_only,
			},
		};
		return SharedTrainingSvc.index(params).then((response) => {
			self.franchiseCourses = response.data.course_collection;
			self.totalFranchise = response.data.count;
			self.franchiseLoading = false;
		});
	}

	function loadEmployeeTraining() {
		self.employeeLoading = true;
		let params = {
			page: self.employeePage,
			count: 20,
			filter: {
				employeeCourse: true,
				employeeCompleted: self.filter.employee.status !== 'outstanding',
				search: self.filter.employee.search,
				expiringCoursesOnly: self.filter.employee.show_expiring_courses_only,
			},
		};

		return SharedTrainingSvc.index(params).then((response) => {
			self.employeeCourses = response.data.course_collection;
			self.totalEmployee = response.data.count;
			self.employeeLoading = false;
		});
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.startCourseClick = (item) => {

	};

	handlers.exportClick = () => {
		window.open('/training/export');
	};

	handlers.editCourseClick = (userCourse) => {
		SharedTrainingSvc.showTrainingModal(userCourse).then((result) => {
			if (result.refresh) {
				loadEmployeeTraining();
			}
			else {
				angular.extend(userCourse, result.userCourse);
			}
		});
	};

	handlers.shareCourseClick = (item) => {
		SharedTrainingSvc.showShareModal(item).then((result) => {
			loadFranchiseTraining();
			loadEmployeeTraining();
		});
	};

	handlers.franchiseStatusChanged = (status) => {
		self.filter.franchise.status = status;
		loadFranchiseTraining();
	};

	handlers.onFranchiseSearch = () => {
		loadFranchiseTraining();
	};

	handlers.employeeStatusChanged = (status) => {
		self.filter.employee.status = status;
		loadEmployeeTraining();
	};

	handlers.onEmployeeSearch = () => {
		loadEmployeeTraining();
	};

	handlers.employeeLoadMore = () => {
		loadEmployeeTraining();
	};

	handlers.franchiseLoadMore = () => {
		loadFranchiseTraining();
	};

	handlers.submitClick = () => {

	};
}
